import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { I18nModule } from '@app/i18n';
import { AuthModule } from '@app/auth';
import { SharedModule } from '@app/@shared';
import { ProductService } from '../../services/productservice';
import { ShellComponent } from './shell.component';
import { LegacyHeaderComponent } from '../legacy/header/legacy-header.component';
import { SlideMenuModule } from 'primeng/slidemenu';
import { LegacyFooterComponent } from '../legacy/footer/legacy-footer.component';
import { MegaMenuModule } from 'primeng/megamenu';
import { MenubarModule } from 'primeng/menubar';
import { CarouselModule } from 'primeng/carousel';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
//import {searchServiceFromMobile} from '../../services/data.service';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';

import { InputTextareaModule } from 'primeng/inputtextarea';
import { DropdownModule } from 'primeng/dropdown';

// New home components for consistent header/footer
import { HeaderComponent as SiteHeaderComponent } from '../header/header.component';
import { MenuComponent } from '../menu/menu.component';
import { FooterComponent as SiteFooterComponent } from '../footer/footer.component';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    TranslateModule,
    NgbModule,
    AuthModule,
    I18nModule,
    SharedModule,
    RouterModule,
    MegaMenuModule,
    CarouselModule,
    ButtonModule,
    ToastModule,
    SlideMenuModule,
    MenubarModule,
    AutoCompleteModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    InputTextareaModule,
    DropdownModule,
  ],
  declarations: [
    LegacyHeaderComponent,
    ShellComponent,
    LegacyFooterComponent,
    SiteHeaderComponent,
    MenuComponent,
    SiteFooterComponent,
    LanguageSelectorComponent,
  ],
  providers: [ProductService],
  exports: [
    SiteHeaderComponent,
    MenuComponent,
    SiteFooterComponent,
    LanguageSelectorComponent,
    LegacyHeaderComponent,
    LegacyFooterComponent,
  ],
})
export class ShellModule {}
